import { render } from "./BlockNumbers.vue?vue&type=template&id=2f79ebe4&scoped=true&ts=true"
import script from "./BlockNumbers.vue?vue&type=script&lang=ts"
export * from "./BlockNumbers.vue?vue&type=script&lang=ts"

import "./BlockNumbers.vue?vue&type=style&index=0&id=2f79ebe4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f79ebe4"]])

export default __exports__